<feedback-alert
  [message]="feedbackMessage"
  [showCancel]="true"
  [showConfirm]="true"
  [show]="showFeedback"
  [alertType]="feedbackType"
>
</feedback-alert>
<div class="modal-content mx-4">
  <form [formGroup]="equipmentForm">
    <app-alert
      [message]="alertMessage"
      [show]="showAlert"
      [showCancel]="showCancel"
      [showConfirm]="showConfirm"
      (closed)="showAlert = false"
      (confirmed)="onAlertClosed(true)"
    ></app-alert>

    <div class="modal-body">
      <div>
        <mat-card-title class="text-dark">Cadastro de Ativo</mat-card-title>

        <div class="b-t-1 row">
          <div class="col-sm-6 m-t-24">
            <mat-label class="f-w-600 m-b-8 d-block">Nome</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input matInput formControlName="name" />
              <mat-error
                *ngIf="equipmentForm.get('name')?.hasError('required')"
              >
                O nome é obrigatório
              </mat-error>
            </mat-form-field>

            <mat-label class="f-w-600 m-b-8 d-block m-t-16">
              Código do Ativo/patrimônio
            </mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input matInput formControlName="serial_number" />
            </mat-form-field>

            <mat-label class="f-w-600 m-b-8 d-block m-t-16"
              >Descrição</mat-label
            >
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <textarea
                matInput
                rows="2"
                formControlName="description"
              ></textarea>
            </mat-form-field>
          </div>

          <div class="col-sm-6 m-t-24">
            <mat-label class="f-w-600 m-b-8 d-block">Unidade</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <mat-select
                formControlName="company_uuid"
                (selectionChange)="onCompanyChange($event.value)"
              >
                @for (unity of units; track unity) {
                  <mat-option [value]="unity.uuid">
                    {{ unity.name }}
                  </mat-option>
                }
              </mat-select>
              @if (equipmentForm.get('company_uuid')?.hasError('required')) {
                <mat-error> A unidade é obrigatória </mat-error>
              }
            </mat-form-field>

            <mat-label class="f-w-600 m-b-8 d-block m-t-16">Ambiente</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <mat-select formControlName="environment_uuid">
                @for (environment of environments; track environment) {
                  <mat-option [value]="environment.uuid">
                    {{ environment.name }}
                  </mat-option>
                }
              </mat-select>
              @if (
                equipmentForm.get('environment_uuid')?.hasError('required')
              ) {
                <mat-error> O ambiente é obrigatório </mat-error>
              }
            </mat-form-field>

            <mat-label class="f-w-600 d-block m-b-8">
              Imagens do Ativo
            </mat-label>
            <app-carousel
              [entity]="{ uuid: equipment.uuid, name: 'equipment' }"
            ></app-carousel>
          </div>
        </div>
      </div>

      <div class="text-right m-t-24">
        <button mat-stroked-button color="warn" class="m-r-8" (click)="close()">
          Cancelar
        </button>
        <button
          mat-flat-button
          color="accent"
          (click)="isEditing ? update() : create()"
          [disabled]="!equipmentForm.valid"
          class="cardWithShadow"
        >
          Salvar
        </button>
      </div>
    </div>
  </form>
</div>
